module.exports = __webpack_public_path__ + "img/block-sh-m-1.e236133d.png";